
import { Action } from '@ngrx/store';



export enum CatActionTypes {
  RETRIEVE_CATEGORIES = 'RETRIEVE_CATEGORIES',
  CAT_SUCCESS  = 'SUCCESS_CAT',
  CAT_FAILURE  = 'FAILURE_CAT'
}

export class Categories implements Action {
  readonly type = CatActionTypes.RETRIEVE_CATEGORIES;
  
}
export class CatSuccess implements Action {
  readonly type = CatActionTypes.CAT_SUCCESS;
  constructor(public payload: any) {}
}


export class CatFailure implements Action {
  readonly type = CatActionTypes.CAT_FAILURE;
  constructor(public payload: any) {}
}
export type All =
  | CatSuccess
  | CatFailure
  | Categories;